// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AiModelOut = zod.object({
  "assigned_processes": zod.array(zod.string()),
  "auth": zod.string(),
  "capability": zod.string(),
  "config": zod.record(zod.string(), zod.unknown()),
  "display_name": zod.string(),
  "enabled": zod.boolean(),
  "hosting": zod.string(),
  "key": zod.string(),
  "max_output_tokens": zod.int(),
  "model_id": zod.string(),
  "price_cache_read": zod.union([zod.string(),zod.null()]),
  "price_cache_write": zod.union([zod.string(),zod.null()]),
  "price_input": zod.union([zod.string(),zod.null()]),
  "price_output": zod.union([zod.string(),zod.null()]),
  "sort_order": zod.int(),
  "stored_secrets": zod.array(zod.string()),
  "unusable_reason": zod.union([zod.string(),zod.null()]),
  "vendor": zod.string()
});

export type AiModelOut = zod.input<typeof AiModelOut>;
export type AiModelOutOutput = zod.output<typeof AiModelOut>;
